import React from "react";
import { Card, CardContent, Chip, Tooltip } from "@mui/material";
import { Block, CalendarTodayOutlined } from "@mui/icons-material";
import moment from "moment";
import { config } from "../../services/config";
import ImagenSegura from "../ImagenSegura";
import NotDesign from "../../assets/design-not-available.png";

const FUENTE = "Bricolage Grotesque";

export const urlImagen = (tipo, id) => `${config.URL_API}/eventos/${tipo === "voucher" ? "vouchers" : "tickets"}/${id}/img`;

const nombreTipo = (tipo) => (tipo === "voucher" ? "Voucher" : "Ticket");

const ItemCompraCard = ({ item, tipo, eventoNombre, onExpandir, acciones = null }) => {
  const inicio = item.tarifa?.fechas?.[0]?.fecha?.hora_inicio;

  return (
    <Card sx={{ width: 350, maxWidth: "100%", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", overflow: "hidden" }}>
      <div style={{ position: "relative" }}>
        <ImagenSegura
          src={urlImagen(tipo, item.id)}
          alt={`${nombreTipo(tipo)} ${item.id}`}
          style={{ width: "100%", display: "block", cursor: "zoom-in" }}
          onClick={() => onExpandir({ tipo, id: item.id })}
          showLoader
          fallbackSrc={NotDesign}
        />
        {item.baja && (
          <div style={{
            position: "absolute", inset: 0, display: "flex", justifyContent: "center",
            alignItems: "center", backgroundColor: "rgba(211, 47, 47, 0.15)",
          }}>
            <Block sx={{ fontSize: 80, color: "#d32f2f", opacity: 0.8 }} />
          </div>
        )}
      </div>

      <CardContent>
        {item.baja && (
          <Tooltip
            arrow
            placement="top"
            title={
              <div style={{ fontSize: 13, padding: 4 }}>
                <strong>{nombreTipo(tipo)} deshabilitado</strong>
                <br />
                <strong>Fecha:</strong> {moment(item.baja).format("DD/MM/YYYY HH:mm")}
                <br />
                Si creés que es un error, escribinos: soporte@passgo.com.ar
              </div>
            }
          >
            <Chip icon={<Block />} label="DESHABILITADO" color="error" size="small" sx={{ mb: 2, fontWeight: 600, width: "100%", cursor: "help" }} />
          </Tooltip>
        )}

        <h5 style={{ fontWeight: 600, color: "#0B0060", marginBottom: 4, fontFamily: FUENTE, fontSize: 18 }}>
          {eventoNombre}
        </h5>
        <p style={{ color: "#525252", margin: "8px 0", fontSize: 14, fontWeight: 500, fontFamily: FUENTE }}>
          {item.tarifa?.concepto}
        </p>
        {item.detalle_mesa && (
          <p style={{ color: "#5656ff", margin: "-4px 0 8px", fontSize: 13, fontWeight: 500, fontFamily: FUENTE }}>
            {item.detalle_mesa}
          </p>
        )}
        {inicio && (
          <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
            <CalendarTodayOutlined sx={{ fontSize: 14, color: "#5656ff", mr: "5px" }} />
            <span style={{ fontSize: 14, color: "#525252", fontFamily: FUENTE }}>
              {moment(inicio).format("D [de] MMMM [de] YYYY")}
            </span>
          </div>
        )}

        {acciones}

        <div style={{ marginTop: 12, textAlign: "center", fontSize: 12, color: "#71717A", fontFamily: FUENTE }}>
          {nombreTipo(tipo)} #{item.id}
        </div>
      </CardContent>
    </Card>
  );
};

export default ItemCompraCard;
